import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  .select-control {
    width: 100%;
    height: 1rem;
    padding: 0;
    font-size: 1.4rem;
    position: relative;
  }
  .errorIcon {
    fill: ${({ theme }) => theme.colors.error} !important;
  }
  svg {
    fill: ${({ theme }) => theme.colors.primary};
  }
  .MuiOutlinedInput-notchedOutline {
    border: none;
    border-bottom: 2px ${({ theme }) => theme.colors.primary} solid;
    border-radius: unset;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    width: 30px;
  }
  .MuiOutlinedInput-input {
    padding: 0.2rem 0;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text_gray};
    font-family: 'Futura PT';
  }
`;
